// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___52qNF","loader":"style__loader___2dG2x"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/token/style.css
// module id = 1039
// module chunks = 0